import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import AppImage from '~root/src/components/AppImage.vue?shadow'
window.customElements.define('sps-app-image', wrap(Vue, AppImage))

import COMModal from '~root/src/components/COMModal.vue?shadow'
window.customElements.define('sps-c-o-m-modal', wrap(Vue, COMModal))

import DecideLaterModal from '~root/src/components/DecideLaterModal.vue?shadow'
window.customElements.define('sps-decide-later-modal', wrap(Vue, DecideLaterModal))

import FabricModal from '~root/src/components/FabricModal.vue?shadow'
window.customElements.define('sps-fabric-modal', wrap(Vue, FabricModal))

import ImageMagnifier from '~root/src/components/ImageMagnifier.vue?shadow'
window.customElements.define('sps-image-magnifier', wrap(Vue, ImageMagnifier))

import ImageOptionCard from '~root/src/components/ImageOptionCard.vue?shadow'
window.customElements.define('sps-image-option-card', wrap(Vue, ImageOptionCard))

import ImageOptionCardFabric from '~root/src/components/ImageOptionCardFabric.vue?shadow'
window.customElements.define('sps-image-option-card-fabric', wrap(Vue, ImageOptionCardFabric))

import PrintoutRequest from '~root/src/components/PrintoutRequest.vue?shadow'
window.customElements.define('sps-printout-request', wrap(Vue, PrintoutRequest))

import ProductAddToCartButton from '~root/src/components/ProductAddToCartButton.vue?shadow'
window.customElements.define('sps-product-add-to-cart-button', wrap(Vue, ProductAddToCartButton))

import ProductAddToCartController from '~root/src/components/ProductAddToCartController.vue?shadow'
window.customElements.define('sps-product-add-to-cart-controller', wrap(Vue, ProductAddToCartController))

import ProductCushionSelector from '~root/src/components/ProductCushionSelector.vue?shadow'
window.customElements.define('sps-product-cushion-selector', wrap(Vue, ProductCushionSelector))

import ProductDetails from '~root/src/components/ProductDetails.vue?shadow'
window.customElements.define('sps-product-details', wrap(Vue, ProductDetails))

import ProductFabricSelector from '~root/src/components/ProductFabricSelector.vue?shadow'
window.customElements.define('sps-product-fabric-selector', wrap(Vue, ProductFabricSelector))

import ProductImageSelector from '~root/src/components/ProductImageSelector.vue?shadow'
window.customElements.define('sps-product-image-selector', wrap(Vue, ProductImageSelector))

import ProductLegSelector from '~root/src/components/ProductLegSelector.vue?shadow'
window.customElements.define('sps-product-leg-selector', wrap(Vue, ProductLegSelector))

import ProductOptionButtons from '~root/src/components/ProductOptionButtons.vue?shadow'
window.customElements.define('sps-product-option-buttons', wrap(Vue, ProductOptionButtons))

import ProductOptionSelector from '~root/src/components/ProductOptionSelector.vue?shadow'
window.customElements.define('sps-product-option-selector', wrap(Vue, ProductOptionSelector))

import ProductOptionSelectorAlt from '~root/src/components/ProductOptionSelectorAlt.vue?shadow'
window.customElements.define('sps-product-option-selector-alt', wrap(Vue, ProductOptionSelectorAlt))

import ProductRadioButtons from '~root/src/components/ProductRadioButtons.vue?shadow'
window.customElements.define('sps-product-radio-buttons', wrap(Vue, ProductRadioButtons))

import ProductRangeSlider from '~root/src/components/ProductRangeSlider.vue?shadow'
window.customElements.define('sps-product-range-slider', wrap(Vue, ProductRangeSlider))

import ProductSelectorBox from '~root/src/components/ProductSelectorBox.vue?shadow'
window.customElements.define('sps-product-selector-box', wrap(Vue, ProductSelectorBox))

import ProductSelectorTemplated from '~root/src/components/ProductSelectorTemplated.vue?shadow'
window.customElements.define('sps-product-selector-templated', wrap(Vue, ProductSelectorTemplated))

import ProductSelectorVariable from '~root/src/components/ProductSelectorVariable.vue?shadow'
window.customElements.define('sps-product-selector-variable', wrap(Vue, ProductSelectorVariable))

import ProductSizeDisplay from '~root/src/components/ProductSizeDisplay.vue?shadow'
window.customElements.define('sps-product-size-display', wrap(Vue, ProductSizeDisplay))

import TextOptionCard from '~root/src/components/TextOptionCard.vue?shadow'
window.customElements.define('sps-text-option-card', wrap(Vue, TextOptionCard))

import VariantCustomSelect from '~root/src/components/VariantCustomSelect.vue?shadow'
window.customElements.define('sps-variant-custom-select', wrap(Vue, VariantCustomSelect))